import React, { useRef, useState } from "react";
import { backendUrl } from "../../constants";

const CampaignCarousel = ({ images = [] }) => {
    const scrollRef = useRef(null);
    const thumbRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    const dummyBanner = "/assets/img/peopleAi.png";

    const safeImages = images?.length ? images : [{ filename: null }];

    const getImageSrc = (img) => {
        if (!img) return dummyBanner;
        if (typeof img === "string") return img;
        if (img?.filename) return backendUrl + img.filename;
        return dummyBanner;
    };

    const handleScroll = () => {
        const scrollLeft = scrollRef.current.scrollLeft;
        const width = scrollRef.current.clientWidth;
        const index = Math.round(scrollLeft / width);
        setActiveIndex(index);
    };

    const goNext = () => {
        if (activeIndex < safeImages.length - 1) {
            scrollRef.current.scrollTo({
                left: scrollRef.current.clientWidth * (activeIndex + 1),
                behavior: "smooth"
            });
        }
    };

    const goPrev = () => {
        if (activeIndex > 0) {
            scrollRef.current.scrollTo({
                left: scrollRef.current.clientWidth * (activeIndex - 1),
                behavior: "smooth"
            });
        }
    };

    // 🔥 Thumbnail scroll
    const scrollThumbNext = () => {
        thumbRef.current.scrollBy({ left: 200, behavior: "smooth" });
    };

    const scrollThumbPrev = () => {
        thumbRef.current.scrollBy({ left: -200, behavior: "smooth" });
    };

    return (
        <div className="cmp-wrapper">

            {/* MAIN SLIDER */}
            <div className="cmp-slider-container">
                <div
                    className="cmp-slider"
                    ref={scrollRef}
                    onScroll={handleScroll}
                >
                    {safeImages.map((img, index) => (
                        <div className="cmp-slide" key={index}>
                            <img
                                src={getImageSrc(img)}
                                alt="banner"
                                className="cmp-banner-img"
                                onError={(e) => (e.target.src = dummyBanner)}
                            />
                            <div className="cmp-gradient-overlay"></div>
                        </div>
                    ))}
                </div>

                {safeImages.length > 1 && (
                    <div className="cmp-controls">
                        <div className="cmp-dots">
                            {safeImages.map((_, i) => (
                                <div
                                    key={i}
                                    className={`cmp-dot ${activeIndex === i ? "cmp-dot-active" : ""}`}
                                />
                            ))}
                        </div>

                        <div className="cmp-arrows">
                            <button onClick={goPrev} className="cmp-arrow-btn">←</button>
                            <button onClick={goNext} className="cmp-arrow-btn">→</button>
                        </div>
                    </div>
                )}
            </div>

            {/* THUMBNAILS WITH ARROWS */}
            {images?.length > 0 && (
                <div className="cmp-thumb-wrapper">

                    {/* LEFT ARROW */}
                    {images.length > 6 && (
                        <button className="cmp-thumb-arrow left" onClick={scrollThumbPrev}>
                            ←
                        </button>
                    )}

                    <div className="cmp-thumb-container" ref={thumbRef}>
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={getImageSrc(img)}
                                alt="thumb"
                                className={`cmp-thumb ${activeIndex === index ? "cmp-thumb-active" : ""}`}
                                onError={(e) => (e.target.src = dummyBanner)}
                                onClick={() =>
                                    scrollRef.current.scrollTo({
                                        left: scrollRef.current.clientWidth * index,
                                        behavior: "smooth"
                                    })
                                }
                            />
                        ))}
                    </div>

                    {/* RIGHT ARROW */}
                    {images.length > 6 && (
                        <button className="cmp-thumb-arrow right" onClick={scrollThumbNext}>
                            →
                        </button>
                    )}

                </div>
            )}
        </div>
    );
};

export default CampaignCarousel;